import React, { ReactElement, useContext, useEffect } from 'react';
import classNames from 'classnames';
import { TeApiContext } from '@ecommerce/nest-ssr/common';
import ReactDOM from 'react-dom';

import './menu-overlay.scss';

const MenuOverlay: React.FC<{
    onClose: () => void;
    className?: string;
    topPosition?: number;
}> = ({ onClose, className, topPosition = 92 }): ReactElement | null => {
    const api = useContext(TeApiContext);

    if (api === null) {
        throw new Error('Invalid API context');
    }

    useEffect(() => {
        if (api.getDevice() === 'mobile') {
            document.body.style.overflow = 'hidden';
        }

        return () => {
            if (api.getDevice() === 'mobile') {
                document.body.style.overflow = '';
            }
        };
    }, [api]);

    return ReactDOM.createPortal((
        <div
            className={classNames('menu-overlay', className)}
            onClick={onClose}
            role="none"
            style={{ top: `${topPosition}px` }}
        />
    ), document.body);
};

export default MenuOverlay;
